import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { I18nProvider } from "@/i18n/I18nContext";
import LenisProvider from "@/components/LenisProvider";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import ThankYou from "@/pages/ThankYou";
import LegalPage from "@/pages/LegalPage";

function LangShell() {
  return (
    <>
      <Header />
      <Routes>
        <Route index element={<Home />} />
        <Route path="privacy_policy" element={<LegalPage i18nKey="privacy_policy" testId="privacy-policy-page" />} />
        <Route path="cookie_policy" element={<LegalPage i18nKey="cookie_policy" testId="cookie-policy-page" />} />
        <Route path="terms_and_conditions" element={<LegalPage i18nKey="terms" testId="terms-page" />} />
      </Routes>
      <Footer />
    </>
  );
}

function AppRoutes() {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/ar" replace />} />
      <Route path="/thank_you" element={<ThankYou />} />
      <Route path="/ar/*" element={<LangShell />} />
      <Route path="/en/*" element={<LangShell />} />
      <Route path="*" element={<Navigate to="/ar" replace />} />
    </Routes>
  );
}

function AppInner() {
  const location = useLocation();
  const isThankYou = location.pathname === "/thank_you";
  return (
    <>
      <ScrollToTop />
      <AppRoutes />
      {!isThankYou && <CookieBanner />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <LenisProvider>
            <AppInner />
          </LenisProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
